import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useList } from "react-firebase-hooks/database";
import { ref } from "firebase/database";
import { db } from "../../firebase";
import { Icon } from "leaflet";
import userDroneMarkerPng from "../../assets/droneMarker.png";
import { LayersControl, Marker, Popup, FlyTo, useMapEvents } from "react-leaflet";
import Legend from "../../components/legends/legends";

const { Overlay } = LayersControl;
const DroneDetailsMapView = () => {
    const { droneId } = useParams();
    const [dronesData] = useList(ref(db, "drones/"));
    const [fireDrones, setDrones] = useState([]);

    useEffect(() => {
        const droneData = dronesData.filter((snap) => snap.key == droneId).map((snap) => ({ droneId: snap.key, info: snap.val() }))
        setDrones(droneData);
    }, [dronesData]);

    const map = useMapEvents({

        locationfound(e) {
            map.flyTo(
                { lat: fireDrones[0].info.utm.currentPosition.lat, lng: fireDrones[0].info.utm.currentPosition.lng },
                18,
            );
        },
    });

    useEffect(() => {
        // Only trigger useMapEvents when fireDrones changes
        if (fireDrones.length > 0) {
            map.flyTo(
                { lat: fireDrones[0].info.utm.currentPosition.lat, lng: fireDrones[0].info.utm.currentPosition.lng },
                18,
            );
        }
    }, [fireDrones]);
    const legendData = [
        {
            title: "User Drone",
            img: userDroneMarkerPng,
        },
    ];


    return (
        <>
            <Overlay checked name="Overlay Layer">
                <>
                    {fireDrones.length > 0 && <Marker
                        position={[
                            fireDrones[0].info.utm.currentPosition.lat,
                            fireDrones[0].info.utm.currentPosition.lng,
                        ]}
                        icon={
                            new Icon({
                                iconUrl: userDroneMarkerPng,
                                iconSize: [50, 50],
                                iconAnchor: [25, 25],
                            })
                        }
                    >
                        <Popup>
                            <span className="font-extrabold capitalize">{fireDrones[0].info.utm.droneName}</span>
                            <br />
                            <span>{fireDrones[0].info.utm.currentPosition.lat},{fireDrones[0].info.utm.currentPosition.lng}</span>
                        </Popup>
                    </Marker>}
                </>
                <Legend data={legendData} />

            </Overlay>
        </>
    )
}

export default DroneDetailsMapView